/**
 * Calcule une clé de version stable pour un objet bien.
 *
 * Utilisé par `useSessionState` dans les pages détail (Bien, SuiviEls,
 * EtatDesLieux) pour invalider le cache sessionStorage du formulaire
 * quand la DB a été mise à jour depuis une autre source (autre onglet,
 * autre admin, import Rentio, etc.).
 *
 * Stratégie :
 * - Si `bien.updated_at` est set → on l'utilise (cheap + précis).
 * - Sinon → on hache les champs du bien. N'importe quel changement en
 *   DB produit un hash différent → sessionStorage invalidé.
 *
 * Ce fallback couvre le cas des rows avec `updated_at` NULL (rows seedées,
 * imports Rentio passés, etc.) qui provoquaient un cache sessionStorage
 * persistant "new" → data form stale sans moyen de s'en défaire.
 */

function djb2(str: string): string {
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h) ^ str.charCodeAt(i);
  }
  return (h >>> 0).toString(36);
}

export function computeBienVersion(bien: object): string {
  const updatedAt = (bien as { updated_at?: string | null }).updated_at;
  if (updatedAt) return updatedAt;
  try {
    // Stable tant que le contenu du bien ne change pas. Si la DB renvoie
    // une nouvelle valeur sur n'importe quel champ, le hash change et
    // useSessionState reset le form.
    return "h:" + djb2(JSON.stringify(bien));
  } catch {
    return "new";
  }
}
